import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import cart from './modules/cart'
import event from './modules/event'
import prints from './modules/prints'
import digitalItems from './modules/digital-items'
import websocket from './modules/websocket'
import appConfig from "@/store/modules/appConfig";

import supportStore from '../domain/support/store'
import supportService from '../domain/support/service'

import sharedStore from '../domain/shared/store'
import sharedService from '../domain/shared/service'

import checkinStore from '../domain/checkin/store'
import checkinDetailStore from '../domain/checkinDetail/store'

import impersonateStore from '../domain/impersonate/store'
import impersonateService from '../domain/impersonate/service'


import bannerGetPica from '../domain/bannerGetPica/store'

import eventService from '../services/Event'

import mediaStoreAllPhotos from '../domain/media/allPhotos/store'
import mediaStoreGalleries from '../domain/media/galleries/store'
import mediaService from '../domain/media/service'

import cartService from '../domain/cart/service'
import cartStore from '../domain/cart/store'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        noScroll: false,
        faceRecognitionCheckin: null,
        faceRecognitionCheckinFaces: [],
        faceRecognitionCheckinCallback: undefined,
        livenessDetectionEnabled: false,
        stayMode: null,
        faceCheckinPrivacyStatement: null,
        prechekinEventName: '',
        precheckinDataCollectorFormUrl: '',
        precheckinDataCollectorFormUseIframe: false,
        checkinOptions: {},
        autoCheckinPicacode: '',
        showMarketingCheck: false,
        isPreviewCheckin: false,
        disableSocialLoginInPreview: false,
        autoCheckinSource: '',
        autoCheckinTags: '',
        voucherToReedem: '',
        redirectTo: undefined,
        minRequiredAgeAccepted: localStorage.getItem('minRequiredAgeAccepted') === 'true',
        customModalCheckinDetailShown: localStorage.getItem('customModalCheckinDetailShown') ? JSON.parse(localStorage.getItem('customModalCheckinDetailShown')) : {},
        thirdLevelDomain: location.hostname.split('.').reverse()[2],
    },

    mutations: {
        SET_NO_SCROLL (state) {
            state.noScroll = true
        },

        UNSET_NO_SCROLL (state) {
            state.noScroll = false
        },

        SET_AUTO_CHECKIN_PICACODE (state, payload) {
            state.autoCheckinPicacode = payload
        },

        SET_AUTO_CHECKIN_SHOW_MARKETING_CHECK(state, payload) {
            state.showMarketingCheck = payload
        },

        SET_IS_PREVIEW_CHECKIN(state) {
            state.isPreviewCheckin = true
        },
        SET_AUTO_CHECKIN_SOURCE (state, payload) {
            state.autoCheckinSource = payload
        },
        SET_AUTO_CHECKIN_TAGS (state, payload) {
            state.autoCheckinTags = payload
        },

        RESET_IS_PREVIEW_CHECKIN(state) {
            state.isPreviewCheckin = false
        },

        SET_VOUCHER_TO_REEDEM (state, payload) {
            state.voucherToReedem = payload
        },

        SET_REDIRECT_TO (state, to) {
            state.redirectTo = to
        },
        SET_CUSTOM_MODAL_CHECKIN_DETAIL_SHOWN (state, value) {
            state.customModalCheckinDetailShown = {...state.customModalCheckinDetailShown, ...value}
            localStorage.setItem('customModalCheckinDetailShown', JSON.stringify(state.customModalCheckinDetailShown))
        },
        CLEAR_CUSTOM_MODAL_CHECKIN_DETAIL_SHOWN (state) {
            state.customModalCheckinDetailShown = {}
            localStorage.removeItem('customModalCheckinDetailShown')
        },
        SET_DISABLE_SOCIAL_LOGIN_IN_PREVIEW (state, value) {
            state.disableSocialLoginInPreview = value
        },
        SET_MIN_REQUIRED_AGE_ACCEPTED (state, value) {
            state.minRequiredAgeAccepted = value
            localStorage.setItem('minRequiredAgeAccepted', value)
        }
    },

    actions: {
        clearAutoCheckinState(context) {
            context.commit('SET_AUTO_CHECKIN_PICACODE', '')
            context.commit('SET_AUTO_CHECKIN_SOURCE', '')
            context.commit('SET_AUTO_CHECKIN_TAGS', '')
        }
    },

    getters: {
        getAutoCheckinPicacode: (state) => state.autoCheckinPicacode,
        getAutoCheckinSource: (state) => state.autoCheckinSource,
        getAutoCheckinTags: (state) => state.autoCheckinTags,
        getVoucherToReedem: (state) => state.voucherToReedem,
        isPicaThirdLevelDomain: (state) => state.thirdLevelDomain === undefined || ['www', 'www-dev', 'www-test'].includes(state.thirdLevelDomain),
        getRedirectTo: (state) => state.redirectTo,
        getCustomModalCheckinDetailShown: (state) => (picaServiceId) => {
            if (localStorage.getItem('customModalCheckinDetailShown')) {
                state.customModalCheckinDetailShown = JSON.parse(localStorage.getItem('customModalCheckinDetailShown'))
            }
            return state.customModalCheckinDetailShown[picaServiceId]
        },
        minRequiredAgeAccepted: (state) => state.minRequiredAgeAccepted,
        checkinOptions: (state) => state.checkinOptions,
        thirdLevelDomain: (state) => state.thirdLevelDomain,
        showMarketingCheck: (state) => state.showMarketingCheck,
        disableSocialLoginInPreview: (state) => state.disableSocialLoginInPreview,

    },

    modules: {
        auth,
        cart,
        prints,
        digitalItems,
        websocket,
        appConfig,
        event,
        support: supportStore(supportService),
        shared: sharedStore(sharedService),
        checkin: checkinStore(eventService),
        checkinDetail: checkinDetailStore(eventService),
        impersonate: impersonateStore(impersonateService),
        bannerGetPica,
        mediaAllPhotos: mediaStoreAllPhotos(mediaService),
        galleries: mediaStoreGalleries(mediaService),
        cartDigitalItems: cartStore(cartService),
    },
})
